import Axios from "axios";
import type { BookingScheduleInterface } from "../../../features/Booking-Form/typings/booking.types";

export type PatchConferenceVisitorRegistrationBody = {
  firstName?: string;
  surname?: string;
  email?: string;
  company?: string;
  contacts?: string;
  visitReason?: string;
  locationInventoryId?: number;
};

export type PatchConferenceVisitorRegistrationVariables = {
  visitorRegistrationId: number;
  body: PatchConferenceVisitorRegistrationBody;
};

export const patchConferenceVisitorRegistration = ({
  visitorRegistrationId,
  body
}: PatchConferenceVisitorRegistrationVariables) =>
  Axios.patch<BookingScheduleInterface>(
    `/booking/conference-visitor-registrations/${visitorRegistrationId}`,
    body
  );
